export class UpdateFleetUserRequest {
    customerId?: string;
    userEmail?: string;
    fleetKind?: string;
    isEnabled?: boolean;
    allowList?: string[];
}